//获取文件扩展名
export default (name) => {
  let fileName = name.lastIndexOf(".");//取到文件名开始到最后一个点的长度
  let fileFormat = name.substring(fileName, name.length);//截
  return fileFormat;
}
